import {
  DvCheckboxElement,
  DvCheckboxElementParams,
  DvFormElementParams,
  FormType,
} from '@devinco/ui/dds';
import { FormElementExtra } from './form.element';

export class VtCheckboxElement<
  TForm extends FormType = FormType,
  TFormContext = any,
> extends DvCheckboxElement<TForm, TFormContext> {
  constructor(params: VtCheckboxElementParams<TForm, TFormContext>) {
    super(params);
    params.elementParams ??= {};
    params.extra ??= {};
  }
}

export interface VtCheckboxElementParams<
  TForm extends FormType,
  TFormContext = any,
> extends DvFormElementParams<{
  TForm: TForm;
  TFormContext: TFormContext;
  TElementParams: DvCheckboxElementParams;
}> {
  extra?: FormElementExtra;
}
